module.exports = __webpack_public_path__ + "img/openConversation.5a5af607.svg";